<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <router-view />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
export default {
  name: 'Home',
  components: {Loading},
  data: () => ({
    maintenanceTime: [],
    startTime_date:'',
    startTime_time:'',
    endTime_date:'',
    endTime_time:'',
    isLoading: false,
  }),
  mounted(){
    this.getMaintenanceTime()
  },
  methods:{
    redirectPath(path){
      this.$router.push(path)
    },
    getMaintenanceTime(){
      this.isLoading = true
      var self = this
      var request = {
        method: 'GET',
        url: '/common/typevByCategory/maintenanceTime',
        params: {},
      }
      this.$http(request).then(function(response) {
        self.maintenanceTime = response.data.data[0]
      }).catch(()=>{
        self.isLoading = false
        console.log('系統錯誤','請聯繫系統管理人員，編號為Bif-7976')
      }).finally(()=>{
        const maintenance = JSON.parse(self.maintenanceTime.name)
        const start = maintenance.find(item => item.name === 'start')
        const end = maintenance.find(item => item.name === 'end')

        if (start) {
          this.startTime_date = start.date
          this.startTime_time = start.time
        }
        if (end) {
          this.endTime_date = end.date
          this.endTime_time = end.time
        }

        // 建立完整的時間字串
        const startDateTime = `${this.startTime_date} ${this.startTime_time}:00`
        const endDateTime = `${this.endTime_date} ${this.endTime_time}:00`

        // 轉成可比較的時間（毫秒）
        const now = new Date()
        const startTime = new Date(startDateTime)
        const endTime = new Date(endDateTime)

        // 比較
        if (now >= startTime && now <= endTime) {
          this.isLoading = false
          this.redirectPath('/maintenance')
        } else {
          if (this.$route.path !== '/portal') {
            this.$router.push('/registration')
          }
          this.isLoading = false
        }
      })
    },

  }
}
</script>